'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useButton } from '@react-aria/button';
import { noTooltipInternal } from '../icon-button/icon-button-internal.utils.js';
import { useFloatingLabelTextInputElement } from '../../contexts/internal/floating-label/index.js';
import { useSwanComboboxContext } from './combobox.context.js';
import { TextInput } from '../text-input/text-input.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { className } from '../../../core/utilities/classnames.utils.js';
import { RenderComp } from '../core/render-comp.component.js';
import { IconButton } from '../icon-button/icon-button.component.js';
import { Icon } from '../icon/icon.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
const ComboboxInput = renderWithRef('ComboboxInput', null, (s, f)=>{
    let { buttonRef: _, buttonProps: j, inputRef: d, inputProps: y, menuTrigger: O } = useSwanComboboxContext(), { buttonProps: w } = useButton(_object_spread_props(_object_spread({}, j), {
        isDisabled: s.disabled
    }), _), x = assignRefs(f, d), g = useFloatingLabelTextInputElement(_object_spread_props(_object_spread({}, y, s), {
        onBlur: (e)=>{
            var t, r;
            null === (t = s.onBlur) || void 0 === t || t.call(s, e), null === (r = y.onBlur) || void 0 === r || r.call(y, e);
        },
        className: className(s.className, 'swan-combobox')
    }));
    return jsxs(Fragment, {
        children: [
            jsx(RenderComp, {
                forwardedRef: x,
                root: TextInput,
                props: _object_spread_props(_object_spread({}, g), {
                    type: 'text'
                })
            }),
            'focus' === O && jsx(IconButton, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
                ref: _
            }, w), {
                tooltip: ""
            }), noTooltipInternal), {
                className: "swan-combobox-button",
                skin: "tertiary",
                children: w['aria-expanded'] ? jsx(Icon, {
                    iconType: "caretUp"
                }) : jsx(Icon, {
                    iconType: "caretDown"
                })
            }))
        ]
    });
});

export { ComboboxInput };
